var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckInfos = function SvgCheckInfos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.75v6m3.375-6v6m3.75-6v6m3.375-6v6m-12 1.2v.6c0 .42 0 .63.082.79a.75.75 0 0 0 .328.328c.16.081.37.081.79.081h11.1c.42 0 .63 0 .79-.082a.75.75 0 0 0 .328-.327c.082-.16.082-.37.082-.79v-.6c0-.42 0-.63-.082-.791a.75.75 0 0 0-.327-.328c-.16-.082-.371-.082-.791-.082H2.45c-.42 0-.63 0-.79.082a.75.75 0 0 0-.328.328c-.082.16-.082.37-.082.79ZM7.74 1.306 2.19 2.54c-.336.075-.503.112-.628.202a.75.75 0 0 0-.251.313c-.061.142-.061.313-.061.657v.837c0 .42 0 .63.082.79a.75.75 0 0 0 .328.329c.16.081.37.081.79.081h11.1c.42 0 .63 0 .79-.081a.75.75 0 0 0 .328-.328c.082-.16.082-.37.082-.79v-.838c0-.344 0-.515-.06-.657a.75.75 0 0 0-.252-.313c-.125-.09-.292-.127-.628-.202L8.26 1.307a1.56 1.56 0 0 0-.194-.037.749.749 0 0 0-.132 0 1.56 1.56 0 0 0-.194.037Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCheckInfos;